/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { SmsTemplateDetails } from '../../../resources/sms-templates.model';

export interface SmsTemplatePreviewDialogConfig {
  template: SmsTemplateDetails;
}

@Component({
  standalone: false,
  selector: 'gh-sms-template-preview-dialog',
  templateUrl: 'sms-template-preview-dialog.component.html',
  styleUrls: ['sms-template-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsTemplatePreviewDialogComponent implements DialogInput<SmsTemplatePreviewDialogConfig> {
  input: SmsTemplatePreviewDialogConfig;

  constructor(private dialogRef: MatDialogRef<any>) {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

export const smsTemplatePreviewDialogRoute = createDialogRoute({
  component: SmsTemplatePreviewDialogComponent,
  config: {
    autoFocus: false,
    maxHeight: '92vh',
    width: '500px',
    maxWidth: '96vw',
  },
});
